import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { AssetIcon } from '@/presentation/components/common/icon/AssetIcon';

type LayoutOrientation = 'left' | 'center';

interface FlexibleHeaderBackgroundProps {
  backgroundColor?: string;
  iconPath?: string;
  title?: string;
  layoutOrientation?: LayoutOrientation;
}

export const FlexibleHeaderBackground: React.FC<FlexibleHeaderBackgroundProps> = ({
  backgroundColor,
  iconPath,
  title,
  layoutOrientation = 'left',
}) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: responsive.flexibleHeader.height,
        borderRadius: responsive.flexibleHeader.borderRadius,
        backgroundColor: backgroundColor ?? theme.background,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: layoutOrientation === 'left' ? 'flex-start' : 'center',
        paddingLeft: layoutOrientation === 'left' && !iconPath ? responsive.spacing.lg : undefined,
        gap: responsive.gap.base,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(to bottom, 
          ${theme.gradientBackground} 0%, transparent 0%, transparent 0%, 
          ${theme.gradientBackground} 100%)`,
          pointerEvents: 'none',
        }}
      />
      {iconPath && (
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            width: responsive.flexibleHeader.iconContainerSize,
            height: responsive.flexibleHeader.iconContainerSize,
            borderRadius: responsive.flexibleHeader.iconContainerBorderRadius,
            background: `linear-gradient(to bottom right, transparent 0%, ${theme.gradientBackground} 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AssetIcon
            path={iconPath}
            width={responsive.icon.xlarge}
            height={responsive.icon.xlarge}
            color={theme.icon.primary}
          />
        </div>
      )}
      {title && (
        <span
          style={{
            position: 'relative',
            zIndex: 1,
            fontSize: responsive.font['5xl'],
            fontWeight: responsive.fontWeight.bold,
            color: theme.text.primary,
          }}
        >
          {title}
        </span>
      )}
    </div>
  );
};
